import { render, staticRenderFns } from "./productGroupEdit.vue?vue&type=template&id=5d0822bc&scoped=true"
import script from "./productGroupEdit.vue?vue&type=script&lang=js"
export * from "./productGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./productGroupEdit.vue?vue&type=style&index=0&id=5d0822bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0822bc",
  null
  
)

export default component.exports